module.exports = __webpack_public_path__ + "static/media/snowboarding_1366.497169fb.jpg";